import { connect } from 'react-redux';
import * as selectors from 'selectors';
import Modal from 'comp/modals/edit_group';
import { cache } from 'utils';

const mapToProps = state => {
  return {
    status: state.fetch.group_update || cache.empty_obj,
    selected: selectors.getSelectedGroup()
  };
};

export default connect(mapToProps)(Modal);



// WEBPACK FOOTER //
// ./src/containers/modals/EditGroup.js